(() => {
  const roots = document.querySelectorAll('[data-epic-beds-ar-gallery]');

  roots.forEach((root) => {
    const dialog = root.querySelector('[data-epic-beds-ar-dialog]');
    const openButton = dialog ? document.querySelector(`[aria-controls="${dialog.id}"]`) : null;
    const closeButton = root.querySelector('[data-epic-beds-ar-close]');
    const viewer = root.querySelector('[data-epic-beds-ar-viewer]');
    const editButton = root.querySelector('[data-epic-beds-ar-edit]');
    const editLayer = root.querySelector('[data-epic-beds-ar-edit-layer]');
    const editCloseButtons = Array.from(root.querySelectorAll('[data-epic-beds-ar-edit-close]'));
    const applyButton = root.querySelector('[data-epic-beds-ar-apply]');
    const placeButton = root.querySelector('[data-epic-beds-ar-place]');
    const configurationButtons = Array.from(root.querySelectorAll('[data-epic-beds-ar-configuration]'));
    const colorButtons = Array.from(root.querySelectorAll('[data-epic-beds-ar-color]'));
    const dimensions = root.querySelector('[data-epic-beds-ar-dimensions]');
    const colorNote = root.querySelector('[data-epic-beds-ar-color-note]');
    const status = root.querySelector('[data-epic-beds-ar-status]');
    const manifestNode = root.querySelector('[data-epic-beds-ar-models]');

    if (
      !dialog
      || !openButton
      || !viewer
      || !editButton
      || !editLayer
      || !applyButton
      || !placeButton
      || !configurationButtons.length
      || !colorButtons.length
      || !manifestNode
    ) return;

    let manifest;
    try {
      manifest = JSON.parse(manifestNode.textContent);
    } catch {
      return;
    }

    let modelViewerPromise;
    let currentConfiguration = resolveInitialConfiguration();
    let currentColor = selectedPdpColor();
    let draftConfiguration = currentConfiguration;
    let draftColor = currentColor;
    let editReturnFocus = null;
    let placementRequestPending = false;
    let placementStartedForRequest = false;

    placeButton.disabled = true;

    function isIOSDevice() {
      return /iPad|iPhone|iPod/.test(navigator.userAgent)
        || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    }

    function unsupportedMessage() {
      if (isIOSDevice()) {
        return 'Open this product page in Safari, then tap Place in my garden.';
      }
      return 'AR is available on a compatible iPhone or Android phone.';
    }

    function normalizeHandle(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-|-$)/g, '');
    }

    function selectedPdpColor() {
      const checked = document.querySelector('.bundles-container input[name="option1"]:checked')
        || document.querySelector('input[name="Color"]:checked')
        || document.querySelector('[data-option-name="Color"] input:checked');
      const handle = normalizeHandle(checked?.value);
      return manifest.colors[handle] ? handle : 'mist-green';
    }

    function resolveInitialConfiguration() {
      const queryValue = normalizeHandle(new URLSearchParams(window.location.search).get('configuration')).replace(/-/g, 'x');
      if (manifest.configurations[queryValue]) return queryValue;

      const checked = Array.from(document.querySelectorAll('.bundles-container input:checked, product-info input:checked'))
        .map((input) => String(input.value || input.dataset.value || ''))
        .find((value) => /\b\d{1,2}\s*(?:x|×|by)\s*\d{1,2}\b/i.test(value));
      const match = checked?.match(/\b(\d{1,2})\s*(?:x|×|by)\s*(\d{1,2})\b/i);
      const key = match ? `${Number(match[1])}x${Number(match[2])}` : '';
      return manifest.configurations[key] ? key : manifest.defaultConfiguration;
    }

    function getModel(configuration, color) {
      return manifest.models.find((model) => model.configuration === configuration && model.color === color);
    }

    function themeContext() {
      const theme = window.Shopify?.theme || {};
      return {
        theme_id: String(theme.id || ''),
        theme_role: String(theme.role || ''),
        storefront_environment: String(theme.role || '').toLowerCase() === 'main' ? 'live' : 'preview',
      };
    }

    function eventPayload(eventName, extra = {}) {
      const configuration = manifest.configurations[currentConfiguration];
      const model = getModel(currentConfiguration, currentColor);
      const theme = themeContext();
      const analyticsEventName = theme.storefront_environment === 'live' ? eventName : `${eventName}_preview`;
      return {
        event: analyticsEventName,
        event_base_name: eventName,
        event_category: 'Epic Beds AR',
        product_id: String(manifest.productId || ''),
        product_handle: manifest.productHandle,
        product_name: manifest.productTitle,
        bed_size: manifest.size,
        bed_height_in: Number(manifest.heightInches),
        bed_configuration: currentConfiguration,
        bed_length_ft: Number(configuration?.lengthFeet),
        bed_width_ft: Number(configuration?.widthFeet),
        bed_color: currentColor,
        model_asset: model?.asset || '',
        ar_supported: viewer.canActivateAR === true,
        ...theme,
        ...extra,
      };
    }

    function track(eventName, extra = {}) {
      const payload = eventPayload(eventName, extra);
      let primaryDataLayer = window.dataLayer;
      if (!primaryDataLayer && Object.isExtensible(window)) {
        try {
          window.dataLayer = [];
          primaryDataLayer = window.dataLayer;
        } catch {
          primaryDataLayer = null;
        }
      }
      if (typeof primaryDataLayer?.push === 'function') primaryDataLayer.push(payload);

      const { event: ga4EventName, ...ga4Parameters } = payload;
      try {
        if (typeof window.gtag === 'function') {
          window.gtag('event', ga4EventName, ga4Parameters);
        } else if (typeof primaryDataLayer?.push === 'function') {
          const queueGoogleTagCommand = function () {
            primaryDataLayer.push(arguments);
          };
          queueGoogleTagCommand('event', ga4EventName, ga4Parameters);
        }
      } catch {
        // Keep the data layer and in-page tracking event available if Google Tag is unavailable.
      }

      if (window.ElevarDataLayer && window.ElevarDataLayer !== primaryDataLayer) {
        try {
          window.ElevarDataLayer.push(payload);
        } catch {
          // The primary dataLayer event remains available to GA4/Elevar.
        }
      }

      root.dispatchEvent(new CustomEvent('epic-beds-ar:tracked', { detail: payload }));
      return payload;
    }

    function syncChoiceButtons() {
      configurationButtons.forEach((button) => {
        const active = button.dataset.epicBedsArConfiguration === draftConfiguration;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      colorButtons.forEach((button) => {
        const active = button.dataset.epicBedsArColor === draftColor;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    function updateModel() {
      const configuration = manifest.configurations[currentConfiguration];
      const model = getModel(currentConfiguration, currentColor);
      if (!configuration || !model) return;

      viewer.setAttribute('src', model.src);
      viewer.setAttribute(
        'alt',
        `${configuration.label} ${manifest.productLabel} Epic Metal Raised Garden Bed in ${manifest.colors[currentColor]}`
      );
      dimensions.textContent = `${configuration.lengthFeet} ft × ${configuration.widthFeet} ft × ${manifest.heightInches} in`;
      colorNote.textContent = manifest.colors[currentColor];
      status.textContent = '';
    }

    function loadModelViewer() {
      if (customElements.get('model-viewer')) return Promise.resolve();
      if (modelViewerPromise) return modelViewerPromise;

      modelViewerPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[data-epic-model-viewer-loader]');
        if (existing) {
          customElements.whenDefined('model-viewer').then(resolve);
          return;
        }

        const script = document.createElement('script');
        script.type = 'module';
        script.src = root.dataset.modelViewerScript;
        script.dataset.epicModelViewerLoader = '';
        script.addEventListener('load', () => customElements.whenDefined('model-viewer').then(resolve), { once: true });
        script.addEventListener('error', reject, { once: true });
        document.head.appendChild(script);
      });

      return modelViewerPromise;
    }

    async function prepareModelViewer() {
      await loadModelViewer();
      if (viewer.updateComplete && typeof viewer.updateComplete.then === 'function') {
        await viewer.updateComplete;
      }
      placeButton.disabled = false;
    }

    function openEditor() {
      draftConfiguration = currentConfiguration;
      draftColor = currentColor;
      syncChoiceButtons();
      editReturnFocus = document.activeElement;
      editLayer.hidden = false;
      requestAnimationFrame(() => editLayer.querySelector('[data-epic-beds-ar-configuration].is-active')?.focus());
      track('beds_ar_edit_opened');
    }

    function closeEditor() {
      editLayer.hidden = true;
      editReturnFocus?.focus?.();
      editReturnFocus = null;
    }

    openButton.addEventListener('click', () => {
      currentColor = selectedPdpColor();
      currentConfiguration = resolveInitialConfiguration();
      draftColor = currentColor;
      draftConfiguration = currentConfiguration;
      syncChoiceButtons();
      updateModel();
      dialog.showModal();
      track('beds_ar_opened');

      placeButton.disabled = true;
      prepareModelViewer().catch((error) => {
        status.textContent = 'The 3D preview could not load. Please try again.';
        track('beds_ar_model_error', { error_type: 'viewer_script_load' });
        console.warn('Epic Beds AR viewer failed to load.', error);
      });
    });

    closeButton?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('cancel', (event) => {
      if (!editLayer.hidden) {
        event.preventDefault();
        closeEditor();
      }
    });
    dialog.addEventListener('close', () => {
      editLayer.hidden = true;
      status.textContent = '';
      placementRequestPending = false;
      placementStartedForRequest = false;
    });

    editButton.addEventListener('click', openEditor);
    editCloseButtons.forEach((button) => button.addEventListener('click', closeEditor));

    configurationButtons.forEach((button) => {
      button.addEventListener('click', () => {
        draftConfiguration = button.dataset.epicBedsArConfiguration;
        syncChoiceButtons();
      });
    });

    colorButtons.forEach((button) => {
      button.addEventListener('click', () => {
        draftColor = button.dataset.epicBedsArColor;
        syncChoiceButtons();
      });
    });

    applyButton.addEventListener('click', () => {
      const previousConfiguration = currentConfiguration;
      const previousColor = currentColor;
      currentConfiguration = draftConfiguration;
      currentColor = draftColor;
      updateModel();
      closeEditor();
      track('beds_ar_configuration_applied', {
        previous_configuration: previousConfiguration,
        previous_color: previousColor,
        changed_configuration: previousConfiguration !== currentConfiguration,
        changed_color: previousColor !== currentColor,
      });
    });

    placeButton.addEventListener('click', () => {
      placementRequestPending = true;
      placementStartedForRequest = false;
      track('beds_ar_placement_requested');

      if (viewer.canActivateAR !== true || typeof viewer.activateAR !== 'function') {
        placementRequestPending = false;
        status.textContent = unsupportedMessage();
        track('beds_ar_unavailable', {
          unavailable_reason: isIOSDevice() ? 'ios_browser_unsupported' : 'device_not_supported',
        });
        return;
      }

      status.textContent = '';
      try {
        track('beds_ar_native_launch');
        Promise.resolve(viewer.activateAR()).catch(() => {
          placementRequestPending = false;
          status.textContent = 'AR could not start. Please try again.';
          track('beds_ar_unavailable', { unavailable_reason: 'activation_failed' });
        });
      } catch {
        placementRequestPending = false;
        status.textContent = 'AR could not start. Please try again.';
        track('beds_ar_unavailable', { unavailable_reason: 'activation_failed' });
      }
    });

    viewer.addEventListener('ar-status', (event) => {
      const arStatus = String(event.detail?.status || '');
      if (arStatus === 'session-started' && placementRequestPending && !placementStartedForRequest) {
        placementStartedForRequest = true;
        track('beds_ar_placement_started');
      }
      if (arStatus === 'failed') {
        placementRequestPending = false;
        status.textContent = 'AR could not start. Please try again.';
        track('beds_ar_unavailable', { unavailable_reason: 'session_failed' });
      }
      if (arStatus === 'not-presenting') {
        placementRequestPending = false;
      }
    });

    viewer.addEventListener('error', () => {
      status.textContent = 'The selected 3D model could not load. Please try another configuration.';
      track('beds_ar_model_error', { error_type: 'model_load' });
    });

    document.addEventListener('change', (event) => {
      if (!event.target.matches('.bundles-container input[name="option1"], input[name="Color"]')) return;
      if (dialog.open && editLayer.hidden) {
        currentColor = selectedPdpColor();
        draftColor = currentColor;
        syncChoiceButtons();
        updateModel();
      }
    });

    syncChoiceButtons();
    updateModel();
  });
})();
